import { ViewModel, View, ViewModelMessage, ObservableArray } from "binder"
import { ChangeThemeMessage } from "src/common/mainWindow/mainWindow-viewModel";
import { distinct, translate } from "src/common/utilities";
import { CssClassListExtractor } from "src/formBuilder/formBuilder/utilities/cssClassListExtractor";
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { MediaSelector } from "uicomponents";
import { AuthenticationView } from "./authentication-view"
import { AuthenticationPhoneView } from "./authenticationPhone/authenticationPhone-view";
declare var authenticationDebugDefaultUserName:string;
declare var authenticationDebugDefaultPassword:string;
declare var systemTitle : string;
declare var companyName : string;
declare var ourCompmanyName : string;
export class AuthenticationViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.sampleData = ObservableArray.create<test>();
        this.selected = ObservableArray.create<test>();
        this.sampleData.update(...[
            new test(this,1,"test1"),
            new test(this,2,"test2"),
            new test(this,3,"test3"),
            new test(this,4,"test4"),
        ])
        // this.selected.update(...[this.sampleData[1],this.sampleData[2]]);
        this.username = authenticationDebugDefaultUserName ?? "";
        this.password = authenticationDebugDefaultPassword ?? "";
        this.systemTitle = systemTitle;
        this.companyName = companyName;
        this.ourCompmanyName = ourCompmanyName;
        let compatibilityIssues = new BrowserCompatibilityChecker().validate();
        if(compatibilityIssues.length>0){
            this.hasCompatibilityIssues = true;
            this.browserCompatibilityIssues = compatibilityIssues.join("\r\n");
        }else{
            this.hasCompatibilityIssues = false;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return MediaSelector.GetView({
            default : ()=>new AuthenticationView(),
            landscapePhone : ()=>new AuthenticationPhoneView(),
            portraitPhone : ()=>new AuthenticationPhoneView(),
        })
        return new AuthenticationView();
    }
    public getTypeId(): string {
        return "VM-7926838A-3D10-4433-913E-C9A1E1AC7794"
    }
    public set sampleData(v: ObservableArray<test>) { this._sampleData = v; } public get sampleData(): ObservableArray<test> { return this._sampleData;} private _sampleData: ObservableArray<test>;
    public set selected(v: ObservableArray<test>) { this._selected = v; } public get selected(): ObservableArray<test> { return this._selected;} private _selected: ObservableArray<test>;
    
    
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isPasswordWrong(v: boolean) { this._isPasswordWrong = v; } public get isPasswordWrong(): boolean { return this._isPasswordWrong;} private _isPasswordWrong: boolean;
    public set browserCompatibilityIssues(v: string) { this._browserCompatibilityIssues = v; } public get browserCompatibilityIssues(): string { return this._browserCompatibilityIssues;} private _browserCompatibilityIssues: string;
    public set hasCompatibilityIssues(v: boolean) { this._hasCompatibilityIssues = v; } public get hasCompatibilityIssues(): boolean { return this._hasCompatibilityIssues;} private _hasCompatibilityIssues: boolean;
    public set systemTitle(v: string) { this._systemTitle = v; } public get systemTitle(): string { return this._systemTitle;} private _systemTitle: string;
    public set companyName(v: string) { this._companyName = v; } public get companyName(): string { return this._companyName;} private _companyName: string;
    public set ourCompmanyName(v: string) { this._ourCompmanyName = v; } public get ourCompmanyName(): string { return this._ourCompmanyName;} private _ourCompmanyName: string;
    
    async login(){
        // this.sampleData.remove(...[this.sampleData.at(0)]);
        // this.sampleData.push(new test(this,"6","test6"));
        // return;
        try {
            this.isLoading = true;
            this.isPasswordWrong = false;
            let result = await ServerConnection.callServerWithUsernameAndPassword('Complex/AuthenticationServices/Login',{},this.username,this.password,[],CurrentCredentials.sessionId);
            if(result.IsSuccessful){
                if(CurrentCredentials.username == this.username && CurrentCredentials.password == this.password){
                    CurrentCredentials.personnelFullName = result.PersonnelFullName ?? "";
                    CurrentCredentials.personnelCode = result.PersonnelCode ?? "";
                    CurrentCredentials.personnelId = result.PersonnelId;
                    CurrentCredentials.sessionId= result.SessionId;
                    this.handleMessage(new ReloginCompletedMessage());
                } else {
                    CurrentCredentials.username = this.username;
                    CurrentCredentials.password = this.password;
                    CurrentCredentials.personnelFullName = result.PersonnelFullName ?? "";
                    CurrentCredentials.personnelCode = result.PersonnelCode ?? "";
                    CurrentCredentials.personnelId = result.PersonnelId;
                    CurrentCredentials.sessionId= result.SessionId;
                    this.handleMessage(new LoginCompletedMessage());
                }
                const fontAndThemeIds : string = result.CurrentTheme ?? ';';
                let themeId = fontAndThemeIds.split(';').at(0) ?? '';
                let fontId = fontAndThemeIds.split(';').at(1) ?? ''
                let changeThemeRequest = new ChangeThemeMessage();
                changeThemeRequest.background = themeId;
                changeThemeRequest.fontId = fontId;
                changeThemeRequest.shallSave = false;
                this.handleMessage(changeThemeRequest);
            } else {
                this.isPasswordWrong = true;
            }
        } catch (ex) {
            this.isPasswordWrong = true;
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class LoginCompletedMessage extends ViewModelMessage { }

export class ReloginCompletedMessage extends ViewModelMessage { }

class BrowserCompatibilityChecker{
    public validate():string[]{
        let result : string[] = [];
        if((CSS.supports("backdrop-filter","blur(40px)")==false && CSS.supports("-webkit-backdrop-filter","blur(40px)")==false)){
            result.push('مرورگر شما به روز نمی باشد. لطفا از آخرین نسخه های Edge, Chrome, Firefox, safari استفاده کنید.');
        }
        return result;
    }
}

export class test extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id,name) {
        super(parent);
        this.id = id;
        this.name = name;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
}